import { z } from "zod";

export const webhookEndpointSchema = z.object({
	id: z.string().optional().nullable(),
	url: z.string().url("Must be a valid URL").min(1, "URL is required"),
	secret: z.string().min(16, "Secret must be at least 16 characters"),
	events: z.array(z.string()).min(1, "Select at least one event"),
	description: z.string().optional().nullable(),
	is_active: z.boolean().default(true),
	webhook_calls_count: z.number().optional(),
	created_at: z.string().optional().nullable(),
	updated_at: z.string().optional().nullable(),
});

export const editWebhookEndpointSchema = webhookEndpointSchema.extend({
	secret: z
		.string()
		.optional()
		.nullable()
		.refine((val) => !val || val.length >= 16, { message: "Secret must be at least 16 characters" }),
});

export type WebhookEndpoint = z.infer<typeof webhookEndpointSchema>;

export const createWebhookEndpointSchema = webhookEndpointSchema.omit({
	id: true,
	webhook_calls_count: true,
	created_at: true,
	updated_at: true,
});

export type CreateWebhookEndpointData = z.infer<typeof createWebhookEndpointSchema>;

export const updateWebhookEndpointSchema = createWebhookEndpointSchema.partial().extend({
	id: z.string(),
});

export type UpdateWebhookEndpointData = z.infer<typeof updateWebhookEndpointSchema>;

export const WEBHOOK_EVENTS = [
	{ value: "project.created", label: "Project Created" },
	{ value: "project.updated", label: "Project Updated" },
	{ value: "supplier.created", label: "Supplier Created" },
	{ value: "supplier.updated", label: "Supplier Updated" },
	{ value: "supplier.deleted", label: "Supplier Deleted" },
] as const;
